module.exports = __webpack_public_path__ + "static/media/hall-P9.76de77f4.svg";